import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fengxian",
  "use": "icon-fengxian-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fengxian\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 83.2a428.8 428.8 0 1 0 0 857.6A428.8 428.8 0 0 0 512 83.2z m0 691.2c-32 0-51.2-25.6-51.2-51.2 0-32 25.6-51.2 51.2-51.2 32 0 51.2 25.6 51.2 51.2s-19.2 51.2-51.2 51.2z m38.4-166.4H473.6l-19.2-332.8h108.8l-12.8 332.8z\" p-id=\"3656\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol